export default "__VITE_ASSET__B8S38Jjm__"